export default "__VITE_ASSET__ba77cc11__"